module.exports = __webpack_public_path__ + "static/squarethree-060551a89b43109704284d21bdfcde1a.jpg";